<template>
  <div class="app-label-number">
    <div v-if="optionPrefix">{{optionPrefix}}</div>
    <div class="el-input el-input--small" :class="optionClass">
      <div class="app-label-number-inner" :class="optionBorderClass">{{value | num}}</div>
    </div>
    <div v-if="optionSuffix">{{optionSuffix}}</div>
  </div>
</template>

<style scoped>
div.app-label-number > div {
  display: inline-block;
}
div.app-label-number div.app-label-number-inner {
  box-sizing: border-box;
  width: 100%;
  height:28px;
  text-align: right;
  padding-right: 16px;
}
div.app-label-number div.app-label-number-inner.bordered {
  border-radius: 4px;
  border: solid 1px rgb(243, 244, 247);
}
.app-label-number .el-input.mini {
  max-width: 55px;
}
.app-label-number .el-input.short {
  max-width: 110px;
}
.app-label-number .el-input.medium {
  max-width: 165px;
}
.app-label-number .el-input.long {
  max-width: 300px;
}
.app-label-number .el-input.full {
  max-width: 1200px;
}
.app-label-number {
  cursor: not-allowed;
}
</style>

<script>
/* eslint-disable semi */
import { Component, Prop } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';

@Component
export default class AppLabelNumber extends AppComponent {
  @Prop({ required: true })
  value;

  @Prop({ required: false, default: null })
  options;

  // クラス
  get optionClass () {
    return (this.options && 'class' in this.options) ? this.options.class : 'medium';
  }

  get optionBorderClass () {
    return (this.options && 'border' in this.options) ? (this.options.border ? 'bordered' : '') : '';
  }

  get optionPrefix () {
    return (this.options && 'prefix' in this.options) ? this.options.prefix : '';
  }

  get optionSuffix () {
    return (this.options && 'suffix' in this.options) ? this.options.suffix : '';
  }

  focus () {
    // 例外スロー
    throw new Error('Can not set focus.');
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/label/AppLabelNumber.vue